import React from "react";
import { Route } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import InitialProducts from "../HOC/InitialProducts";

const RouteLayout = ({ showCategory, component: Component, activePage, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <React.Fragment>
          <Header showCategory={showCategory} />
          <InitialProducts>
            <Component {...matchProps} />
          </InitialProducts>
          <Footer activePage={activePage} />
          <ScrollToTop />
        </React.Fragment>
      )}
    />
  );
};

export default RouteLayout;
